'use strict';

class SuperDashboardController {
    constructor(SSUtilService, SSAnalyticsService, SSUserService) {
        const self = this;

        self.SSUtilService = SSUtilService;
        self.SSAnalyticsService = SSAnalyticsService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
    }

}

SuperDashboardController.$inject = ['SSUtilService', 'SSAnalyticsService', 'SSUserService'];
app.controller('SuperDashboardController', SuperDashboardController);